<template>
  <section>
    <BusinessEntityList :query="query" />
  </section>
</template>
<script>
import BusinessEntityList from '@/components/basic/BusinessEntityList.vue'

export default {
  name: 'BusinessEntities',
  components: { BusinessEntityList },
  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
